import React from 'react';
import { useContext } from 'react';
import { GuideContext } from 'components/Guide';
import { CbButton } from 'ui/components';
import { Card } from 'types';
import styles from './../ContentStyles.module.css';
interface ButtonContentProps {
  content: Card;
}
export const ButtonContent: React.FC<ButtonContentProps> = ({
  content
}) => {
  const {
    setCanGoNext,
    canGoNext,
    onLinkClick
  } = useContext(GuideContext);
  const handleClick = () => {
    onLinkClick();
    window.open(content.mediaUrl, '_blank', 'noopener,noreferrer');
    setCanGoNext(true);
  };
  return <div className={[styles.cardContent, styles.buttonContent].join(' ')} data-sentry-component="ButtonContent" data-sentry-source-file="ButtonContent.tsx">
      <p>{content.title}</p>
      <CbButton onClick={handleClick} data-sentry-element="CbButton" data-sentry-source-file="ButtonContent.tsx">Click Here!</CbButton>
      {!canGoNext && <div className={styles.buttonCardMobileText}>
          <p>
            Visit this link and explore the details. Then, come back to finish
            up.
          </p>
        </div>}
    </div>;
};